// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".my-pagination[data-v-73740d65] .el-pagination__total{float:left}.my-pagination[data-v-73740d65] .el-pagination.is-background .btn-next,.my-pagination[data-v-73740d65] .el-pagination.is-background .btn-prev,.my-pagination[data-v-73740d65] .el-pagination.is-background .el-pager li{background:#fff;border:1px solid #e3e4e9}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
